<template>
	<div
		class="invoice__item"
		:class="{ 'invoice__item--small': item.type === 'variation' }">
		<div class="invoice__item__name">
			<div>
				<router-link
					:to="{ name: 'productDetails', params: { id: item.data.productId } }"
					v-if="item.type === 'product' && !isAdminMode && useLinkProduct">
					{{ item.name }}
				</router-link>
				<span v-else>{{ item.name }}</span>
				<span class="invoice__item__quantity" v-if="item.quantity"> (x{{ item.quantity }})</span>
			</div>
			<div class="invoice__item__metas" v-if="item.meta">
				<div v-for="(meta, metaIndex) in item.meta" :key="metaIndex">{{ meta.trim() }}</div>
			</div>
		</div>
		<div class="invoice__item__price" v-if="item.price !== undefined && item.price !== null && item.price !== ''">
			<div :class="{ 'lined-price': item.discountPrice }">{{ formatMoney(item.price) }}</div>
			<div class="invoice__item__discount" v-if="item.discountPrice">{{ formatMoney(item.discountPrice) }}</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'InvoiceItem',
	props: {
		item: {
			type: Object,
		},
		mode: {
			type: String,
			default: 'user',
		},
		useLinkProduct: {
			type: Boolean,
			default: true,
		},
	},
	computed: {
		isAdminMode() {
			return this.mode === 'admin';
		},
	},
};
</script>
